<template>
  <div class="UserInfo">
    <vue-headful title="USER INFO" />
    <Navbar />
    <fish-segment>
      <a-row>
        <a-col :xs="0" :sm="6" :md="6"  :lg="6"></a-col>
        <a-col :xs="24" :sm="12" :md="12"  :lg="12">
      <fish-card fluid>
        <div slot="header">
          <strong>THAY ĐỔI THÔNG TIN TÀI KHOẢN</strong>
        </div>
        <fish-form style="width: 60%;margin:0 20% 0 20%" ref="frmUserForm">
          <fish-field>
            <fish-input :iconLeft="true" v-model="oUser.Username" icon="fa fa-user" disabled></fish-input>
          </fish-field>
          <fish-field>
            <fish-input :iconLeft="true" v-model="oUser.Name" icon="fa fa-address-card" disabled></fish-input>
          </fish-field>
          <fish-field :rules="[{required: true, message: 'Vui lòng nhập mật khẩu hiện tại!' }]">
            <fish-input
              hint="Mật khẩu hiện tại"
              type="password"
              v-model="oldpass"
              :iconLeft="true"
              icon="fa fa-lock"
            ></fish-input>
          </fish-field>
          <fish-field :rules="[{ required: true, message: 'Vui lòng nhập mật khẩu mới!' }]">
            <fish-input
              hint="Mật khẩu mới"
              type="password"
              v-model="newpass"
              :iconLeft="true"
              icon="fa fa-lock"
            ></fish-input>
          </fish-field>
          <fish-field
            :rules="[{ required: true, message: 'Vui lòng nhập lại chính xác mật khẩu mới!' }]"
          >
            <fish-input
              hint="Nhập lại mật khẩu mới"
              v-model="renewpass"
              type="password"
              :iconLeft="true"
              icon="fa fa-lock"
            ></fish-input>
          </fish-field>
          <a-button @click="ChangeInfo()" type="primary">Thay đổi thông tin</a-button>
        </fish-form>
      </fish-card>
        </a-col>
        <a-col :xs="0" :sm="6" :md="6"  :lg="6"></a-col>
      </a-row>
    </fish-segment>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";

import { mapState } from "vuex";
import { mapActions } from "vuex";

export default {
  name: "UserInfo",
  components: {
    Navbar,
  },
  computed: {
    ...mapState(["isLogin", "oUser"]),
  },
  data() {
    return { oldpass: "", newpass: "", renewpass: "" };
  },
  methods: {
    ...mapActions(["API_Logout", "Go_Route", "API_ChangePass"]),
    async ChangeInfo() {
      if (this.oldpass == "" || this.newpass == "" || this.renewpass == "") {
        this.$message.error("Vui lòng nhập đầy đủ thông tin", 2000);
      } else if (this.newpass.trim.length > 6) {
        this.$message.error("Mật khẩu phải lớn hơn 6 ký tự", 2000);
      } else if (this.newpass != this.renewpass) {
        this.$message.error("Mật khẩu nhập lại không đúng", 2000);
      } else {
        let resData = await this.API_ChangePass({
          oldPass: this.oldpass,
          newPass: this.newpass,
        });
        if (resData.data.State == 1) {
          this.oldpass = "";
          this.newpass = "";
          this.renewpass = "";
          this.$message.success("Thay đổi mật khẩu thành công!", 5000);
        } else {
          this.$message.error(resData.data.Message, 3000);
        }
      }
    },
  },
};
</script>